export default function ChapterHeader({ num, kicker, title, sub }) {
  return (
    <div className="mb-16">
      <div className="flex items-center gap-4 mb-6">
        <span className="chapter-num">Ch. {num}</span>
        <span className="hairline flex-1 max-w-[120px]" />
        <span className="font-mono-label text-[#B8A891]">{kicker}</span>
      </div>
      <h2 className="font-display text-5xl md:text-7xl leading-[1.02] text-[#F2E7D0] max-w-4xl">
        {title}
      </h2>
      {sub && <p className="mt-6 max-w-xl text-[#B8A891] text-base md:text-lg leading-relaxed">{sub}</p>}
    </div>
  );
}
